import api_fetch from '../utils/api_fetch';
import { storageHandler } from '../utils/storage_handler';

const purchaseOrdersService = {
  async getList(page = 1, limit = 20) {
    const offset = (page - 1) * limit;
    const params = new URLSearchParams({ offset, limit });

    return (
      await api_fetch.get(
        `/v1/purchase-orders?${params.toString()}`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {}
      )
    ).json();
  },

  async searchByListField(
    filters = {},
    page = 1,
    sortBy,
    sortOrder,
    limit = 20
  ) {
    const offset = (page - 1) * limit;
    const params = new URLSearchParams();

    params.append('limit', limit.toString());
    params.append('offset', offset.toString());

    Object.entries(filters).forEach(([key, value]) => {
      if (value) {
        params.append(key, value);
      }
    });

    if (
      sortBy &&
      sortOrder &&
      sortBy !== 'default' &&
      sortOrder !== 'default'
    ) {
      params.append('sort_by', sortBy);
      params.append('sort_order', sortOrder);
    }

    const response = await api_fetch.get(
      `/v1/purchase-orders/search?${params.toString()}`,
      {
        Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
      },
      {}
    );

    return response.json();
  },

  async getPurchaseOrder(id) {
    return (
      await api_fetch.get(
        `/v1/purchase-orders/${id}`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {}
      )
    ).json();
  },

  async createPurchaseOrder(data) {
    return (
      await api_fetch.post(
        `/v1/purchase-orders`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {},
        '',
        data
      )
    ).json();
  },

  async updatePurchaseOrder(id, data) {
    return (
      await api_fetch.put(
        `/v1/purchase-orders/${id}`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {},
        '',
        data
      )
    ).json();
  },

  async getTrackingByPO(id) {
    return (
      await api_fetch.get(
        `/v1/purchase-orders/${id}/tracking`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {}
      )
    ).json();
  },

  async getTrackingByPOFromOdata(id) {
    return (
      await api_fetch.get(
        `/v1/purchase-orders/${id}/tracking/odata`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {}
      )
    ).json();
  },

  async getTrackingLogsByPO(id) {
    return (
      await api_fetch.get(
        `/v1/purchase-orders/${id}/tracking-logs`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {}
      )
    ).json();
  },

  async getPurchaseOrderEntries(id) {
    return (
      await api_fetch.get(
        `/v1/purchase-orders/${id}/entries`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {}
      )
    ).json();
  },

  async deletePurchaseOrder(id) {
    return (
      await api_fetch.delete(
        `/v1/purchase-orders/${id}`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {},
        // api_fetch.delete concatenates url + params + query; omitting
        // the 4th argument produced "/v1/purchase-orders/<id>undefined".
        '',
        {}
      )
    ).json();
  }
};


export default purchaseOrdersService;
